// Basic 24-hour countdown simulator for the banner
$(document).ready(function () {
	let hours = 23;
	let minutes = 45;
	let seconds = 44;

	const hoursEl = document.getElementById("lp-mkv2-hours");
	const minutesEl = document.getElementById("lp-mkv2-minutes");
	const secondsEl = document.getElementById("lp-mkv2-seconds");

	function updateTimer() {
		if (seconds > 0) {
			seconds--;
		} else {
			seconds = 59;
			if (minutes > 0) {
				minutes--;
			} else {
				minutes = 59;
				if (hours > 0) {
					hours--;
				} else {
					hours = 23;
				}
			}
		}

		hoursEl.textContent = hours.toString().padStart(2, "0");
		minutesEl.textContent = minutes.toString().padStart(2, "0");
		secondsEl.textContent = seconds.toString().padStart(2, "0");
	}

	// Update every second
	setInterval(updateTimer, 1000);

	if (jQuery(".lp-mkv2-review-slider-desktop").length) {
		jQuery(".lp-mkv2-review-slider-desktop").slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite: true,
			arrows: false,
			dots: false,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
					},
				},
			],
		});
	}

	if (jQuery(".lp-mkv2-review-slider-mobile").length) {
		jQuery(".lp-mkv2-review-slider-mobile").slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: true,
			centerPadding: "20px",
			infinite: true,
			arrows: true,
			dots: false,
			adaptiveHeight: true,
		});
	}

	const navSlider = jQuery(".lp-mkv2-wi-nav-slider");
	const mainSlider = jQuery(".lp-mkv2-wi-main-slider");

	if (navSlider.length && mainSlider.length) {
		navSlider.slick({
			slidesToShow: 7,
			slidesToScroll: 1,
			asNavFor: ".lp-mkv2-wi-main-slider",
			dots: false,
			arrows: false,
			focusOnSelect: true,
			infinite: false,
			responsive: [
				{ breakpoint: 1200, settings: { slidesToShow: 5 } },
				{ breakpoint: 992, settings: { slidesToShow: 4 } },
				{ breakpoint: 768, settings: { slidesToShow: 2.5 } },
			],
		});

		mainSlider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			asNavFor: ".lp-mkv2-wi-nav-slider",
			adaptiveHeight: true,
			infinite: false,
		});

		const prevBtn = jQuery(".lp-mkv2-wi-prev");
		const nextBtn = jQuery(".lp-mkv2-wi-next");
		const currentDisplay = jQuery(".lp-mkv2-current");
		const totalDisplay = jQuery(".lp-mkv2-wi-total");

		const totalSlides = mainSlider.slick("getSlick").slideCount;
		totalDisplay.text(totalSlides);

		function updateNavButtons(currentSlide) {
			if (currentSlide === 0) {
				prevBtn.addClass("lp-mkv2-disabled");
			} else {
				prevBtn.removeClass("lp-mkv2-disabled");
			}

			if (currentSlide === totalSlides - 1) {
				nextBtn.addClass("lp-mkv2-disabled");
			} else {
				nextBtn.removeClass("lp-mkv2-disabled");
			}
		}

		updateNavButtons(0);

		prevBtn.off("click").on("click", function () {
			let currentSlide = mainSlider.slick("slickCurrentSlide");
			if (currentSlide > 0) {
				mainSlider.slick("slickPrev");
			}
		});

		nextBtn.off("click").on("click", function () {
			let currentSlide = mainSlider.slick("slickCurrentSlide");
			if (currentSlide < totalSlides - 1) {
				mainSlider.slick("slickNext");
			}
		});

		mainSlider.on(
			"beforeChange",
			function (event, slick, currentSlide, nextSlide) {
				currentDisplay.text(nextSlide + 1);
				updateNavButtons(nextSlide);
			},
		);
	}

	const whoSlider = jQuery(".lp-mkv2-who-slider");
	const whoPrevBtn = jQuery(".lp-mkv2-who-prev");
	const whoNextBtn = jQuery(".lp-mkv2-who-next");

	if (whoSlider.length) {
		function updateWhoArrows(event, slick, currentSlide, nextSlide) {
			let slideIndex = nextSlide !== undefined ? nextSlide : 0;
			let total = slick.slideCount;

			if (slideIndex === 0) {
				whoPrevBtn.addClass("lp-mkv2-who-disabled");
			} else {
				whoPrevBtn.removeClass("lp-mkv2-who-disabled");
			}

			if (slideIndex === total - 1) {
				whoNextBtn.addClass("lp-mkv2-who-disabled");
			} else {
				whoNextBtn.removeClass("lp-mkv2-who-disabled");
			}
		}

		whoSlider.on("init beforeChange", updateWhoArrows);

		whoSlider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false, 
			dots: false,
			infinite: false,
			adaptiveHeight: true,
		});

		whoPrevBtn.off("click").on("click", function (e) {
			e.preventDefault();
			let currentSlide = whoSlider.slick("slickCurrentSlide");
			if (currentSlide > 0) {
				whoSlider.slick("slickPrev");
			}
		});

		whoNextBtn.off("click").on("click", function (e) {
			e.preventDefault();
			let total = whoSlider.slick("getSlick").slideCount;
			let currentSlide = whoSlider.slick("slickCurrentSlide");
			if (currentSlide < total - 1) {
				whoSlider.slick("slickNext");
			}
		});
	}

	jQuery(".lp-mkv2-chk-card").on("click", function () {
		const clickedCard = jQuery(this);

		if (clickedCard.hasClass("active")) {
			return;
		}

		jQuery(".lp-mkv2-chk-card").removeClass("active");
		clickedCard.addClass("active");

		if (clickedCard.hasClass("lp-mkv2-chk-card-other")) {
			clickedCard
				.find(".lp-mkv2-chk-card-body")
				.stop(true, true)
				.slideDown(300);
		} else {
			jQuery(".lp-mkv2-chk-card-other .lp-mkv2-chk-card-body")
				.stop(true, true)
				.slideUp(300);
		}

		const newTitle = clickedCard.attr("data-title");
		jQuery(".lp-mkv2-chk-dynamic-title").text(newTitle);

		const newImgSrc = clickedCard.attr("data-img");

		const mainImage = jQuery("#lp-mkv2-chk-main-img");
		mainImage.fadeOut(150, function () {
			mainImage.attr("src", newImgSrc).fadeIn(150);
		});
    $(".lp-mkv2-chk-btn").attr("href", clickedCard.attr("data-src-checkout"));
    $(".lp-mkv2-sticky-price-main").html(clickedCard.attr("data-current-price"));
    $(".lp-mkv2-sticky-price-strike").html(clickedCard.attr("data-original-price"));
    $(".lp-mkv2-sticky-title").html(newTitle);
    $('.lp-mkv2-sticky-btn').attr("href", clickedCard.attr("data-src-checkout"));
	});

	$("#adventureAccordion").on("show.bs.collapse", function (e) {
		if (window.innerWidth >= 768) {
			let $triggerBtn = $(e.target).siblings(".card-header").find("button");
			let newImageUrl = $triggerBtn.data("image");
			let $displayImg = $("#bub--nmp-desktop-img");

			$displayImg.fadeOut(200, function () {
				$displayImg.attr("src", newImageUrl).fadeIn(200);
			});
		}
	});

	$("#solutionAccordion .collapse").on("shown.bs.collapse", function () {
		var $showCard = $(this).closest(".card");
		$("html,body").animate(
			{
				scrollTop: $showCard.offset().top - 0,
			},
			500,
		);
	});

	$("#solutionSeeAllBtn").on("click", function (e) {
		e.preventDefault();

		$("#solutionAccordion").addClass("bub--show-all");

		$("#solutionSeeAllWrapper a").hide();
	});

	$(".bub--jump-link").on("click", function (e) {
		e.preventDefault();
		let targetSection = $(this).attr("href");
		let targetSlideName = $(this).data("slide-name");
		let $targetNavItem = $(".lp-mkv2-wi-nav-item[data-slide-name='" + targetSlideName + "']");

		if ($targetNavItem.length > 0) {
			let dynamicIndex = $(".lp-mkv2-wi-nav-item").index($targetNavItem);

			$(".lp-mkv2-wi-main-slider").slick("slickGoTo", dynamicIndex);
			$(".lp-mkv2-wi-nav-slider").slick("slickGoTo", dynamicIndex);
		}

		if ($(targetSection).length > 0) {
			$("html, body").animate(
				{
					scrollTop: $(targetSection).offset().top - 100,
				},
				800,	
			);
		}
	});

  	$('#ias-mosquito-kit .slider-track').slick({
		initialSlide: 0,        
		slidesToShow: 3,        
		slidesToScroll: 1,
		infinite: false,
		arrows: true,
		centerMode: true,
		dots: false,
		autoplay: false,
		variableWidth: false,
		appendArrows: '#review-arrows',
		prevArrow: `
			<button type="button" class="bub--arrow-btn" aria-label="Previous">
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
					<polyline points="15 18 9 12 15 6"></polyline>
				</svg>
			</button>`,
		nextArrow: `
			<button type="button" class="bub--arrow-btn" aria-label="Next">
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
					<polyline points="9 18 15 12 9 6"></polyline>
				</svg>
			</button>`,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: false,
					arrows: false,
					centerMode: true,
					centerPadding: '20px',
					dots: true,
				},
			},
		],
	});

	var $slider = $('#ias-mosquito-kit .slider-track'); 
    var mql = window.matchMedia('(max-width: 767px)');

    function updateSliderItems(e) {
        if ($slider.hasClass('slick-initialized')) {
            $slider.slick('slickUnfilter'); 
            if (e.matches) {
                $slider.slick('slickFilter', function(index) {
                    return index < 3; 
                });
            }
        }
    }
    updateSliderItems(mql);
    if (mql.addEventListener) {
        mql.addEventListener('change', updateSliderItems);
    } else {
        mql.addListener(updateSliderItems);
    }


  const stickyElement = document.querySelector(".lp-mkv2-sticky-wrapper");
  const hideSection = document.querySelector(".lp-mkv2-reviews-section");
  window.addEventListener("scroll", () => {
    if (!stickyElement || !hideSection) return;

    const stickyRect = stickyElement.getBoundingClientRect();
    const sectionRect = hideSection.getBoundingClientRect();

    const isOverlapping = 
      stickyRect.bottom > sectionRect.top && 
      stickyRect.top < sectionRect.bottom;

    if (isOverlapping) {
      stickyElement.classList.add("is-hidden");
    } else {
      stickyElement.classList.remove("is-hidden");
    }
  });


  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (!entry.isIntersecting && !video.paused) {
        video.pause();
      }
    });
  }, {
    threshold: 0.3
  });

  $('video').each(function () {
    videoObserver.observe(this);
  });
});
